import { handleActions } from 'redux-actions'
import { set, flow } from 'lodash/fp'
import { IBranch } from '../types/user'
import {
  SET_MANAGER_BRANCHES,
  SET_MANAGER_ACCOUNT_BRANCHES,
  SET_MANAGER_BRANCH,
  SET_MANAGER_DIVISIONS,
} from './managerActions'

const DEFAULT_STATE = {
  branches: [] as IBranch[],
  accountBranches: [] as IBranch[],
  branch: undefined as IBranch | undefined,
}

export default handleActions<typeof DEFAULT_STATE, any>(
  {
    [SET_MANAGER_BRANCHES]: (
      state: any,
      { payload: { branches, branch } }: SET_MANAGER_BRANCHES,
    ) =>
      flow<any, any, any>(
        set('branches', branches),
        set('branch', branch || branches[0]),
      )(state),
    [SET_MANAGER_BRANCH]: (
      state: any,
      { payload: { branch } }: SET_MANAGER_BRANCH,
    ) => {
      const branches: IBranch[] = state.branches || []
      const updatedBranches = branches.map((b: IBranch) =>
        b.id === branch.id ? branch : b,
      )
      return {
        ...state,
        branch,
        branches: updatedBranches,
      }
    },
    [SET_MANAGER_DIVISIONS]: (state, { payload }: SET_MANAGER_DIVISIONS) =>
      set('divisions', payload, state),
    [SET_MANAGER_ACCOUNT_BRANCHES]: (
      state: any,
      { payload: { branches } }: SET_MANAGER_ACCOUNT_BRANCHES,
    ) => set('accountBranches', branches, state),
  },
  DEFAULT_STATE,
)
